// extracted by mini-css-extract-plugin
module.exports = {"header":"SettingsSidebar_header__3hUGR","status":"SettingsSidebar_status__3vw41","list":"SettingsSidebar_list__1OBxL"};